import { create } from "zustand";

interface SceneReadyStore {
  ready: boolean;
  setReady: () => void;
}

// Flips true once the loading overlay is gone. Used to defer non-critical
// work (e.g. project preview videos) out of the startup path.
export const useSceneReady = create<SceneReadyStore>((set) => ({
  ready: false,
  setReady: () => set({ ready: true }),
}));
